module.exports = __webpack_public_path__ + "img/ica.fdf3be19.png";